import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=98b209fa&scoped=true&"
import script from "./TipTap.vue?vue&type=script&lang=ts&"
export * from "./TipTap.vue?vue&type=script&lang=ts&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=98b209fa&scoped=true&lang=scss&"
import style1 from "./TipTap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b209fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
